<template>
  <fts-design-modal
    width="640px"
    append-header-class="run-app-modal__header"
    class="fts-run-app-modal"
    @closed="reset"
    ref="ftsRunAppModal"
  >
    <!-- header -->
    <template #header>
      <div>&nbsp;</div>
      <fts-btn lg text icon @click="close">
        <font-awesome-icon :icon="['fas', 'times']" />
      </fts-btn>
    </template>
    <!-- body -->
    <template #body>
      <div class="run-app-container">
        <div class="web-container">
          <div class="run-app-label web-run-label">Try yourself in web</div>
          <fts-clipboard :copy="clientUrl">{{clientUrl}}</fts-clipboard>
          <div class="web-run-app">
            <fts-btn color="secondary" outline text-transform-init @click="open">
              Open
            </fts-btn>
          </div>
        </div>

        <div class="mobile-container">
          <div>
            <a class="mobile-store-badge" :href="iOSAppStoreURL" target="_blank">
              <img src="../../assets/images/brand/app-store-black.svg" />
            </a>
            <a class="mobile-store-badge" :href="androindPlayStoreURL" target="_blank">
              <img src="../../assets/images/brand/google-play-badge.svg" />
            </a>
          </div>

          <div class="qrcode">
            <qrcode-vue
              :value="qrCode"
              :size="160"
              render-as="svg"
              foreground="var(--fts-text)"
              background="var(--fts-card-background)"
            />
            <img src="../../assets/images/logo/inistate-logo.png" alt="qrcode-logo" class="qrcode-logo">
          </div>
          <div class="run-app-label">Scan QR Code with Inistate App to sign in instantly.</div>
        </div>
      </div>

      <div class="run-app-divider">
        <div class="divider-line"></div>
        <div class="divider-label">or</div>
        <div class="divider-line"></div>
      </div>

      <div class="invitation-container">
        <div>
          <span class="invitation-toggle" :class="{'fts-link-primary': !invitation}" @click="invitation=true">Invite others user</span>
        </div>
        <template v-if="invitation">
          <div class="invitation-helper">
            New members will be able to see all of {{formData.workspaceName || 'Inistate'}}'s modules that have been shared in the workspace.
          </div>
         <fts-invitation class="invitation-form" />
        </template>
      </div>
    </template>
  </fts-design-modal>
</template>

<script>
import LocalStorageService from '../store/LocalStorageService';
import webAppConfig from '../commons/webApp.config';
import commons from '../commons/commons';

import QrcodeVue from 'qrcode.vue';

import FTSDesignModal from './FTSDesignModal';
import FTSInvitation from '../client/FTSInvitation';
import FTSBtn from '../elements/FTSBtn';
import FTSClipboard from '../elements/FTSClipboard';

export default {
  components: {
    'qrcode-vue': QrcodeVue,
    'fts-design-modal': FTSDesignModal,
    'fts-invitation': FTSInvitation,
    'fts-btn': FTSBtn,
    'fts-clipboard': FTSClipboard
  },
  data: () => ({
    qrCode: null,
    clientUrl: null,
    interval: null,
    invitation: false,
    formData: {}
  }),
  methods: {
    show(item) {
      const generateQrCode = () => {
        this.qrCode = `${webAppConfig.baseURL}?token=${LocalStorageService.getAccessToken()}&refreshToken=${LocalStorageService.getRefreshToken()}&wsId=${commons.encodeids(this.formData.workspaceId)}&nonce=${commons.nanoID(4)}`
      }
      this.formData = _.cloneDeep(item);
      this.clientUrl = `${webAppConfig.baseLocationOrigin}/#/dashboard?wsId=${commons.encodeids(this.formData.workspaceId)}`;
      this.interval = setInterval(() => {
        generateQrCode();
      }, 30000);
      generateQrCode();
      this.$refs.ftsRunAppModal.show();
    },
    close() {
      this.$refs.ftsRunAppModal.close();
      this.reset();
    },
    reset() {
      clearInterval(this.interval);
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    open() {
      this.close();
      const routerResolved = this.$router.resolve({ name: 'dashboard' });
      window.open(routerResolved.href, '_blank');
    }
  },
  created() {
    this.iOSAppStoreURL = commons.iOSAppStoreURL;
    this.androindPlayStoreURL = commons.androindPlayStoreURL;
  },
  beforeDestroy() {
    this.reset();
  }
}
</script>

<style lang="scss">
@use "./src/assets/scss/vars" as *;

.fts-run-app-modal {
  .run-app-modal__header {
    padding-left: 0.75rem;
    padding-right: 0.75rem;
    justify-content: flex-end;
  }
  .run-app-container {
    display: flex;
    flex-wrap: wrap;
    margin-left: -1rem;
    margin-right: -1rem;
    > * {
      flex: 1 1 100%;
      padding-left: 1rem;
      padding-right: 1rem;
      &:not(:last-child) {
        margin-bottom: 2rem;
      }
    }
  }
  @media (min-width: 768px) {
    .run-app-container {
      > * {
        flex: 1 1 50%
      }
    }
  }
  .run-app-label {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }
  .run-app-divider {
    display: flex;
    align-items: center;
    .divider-line {
      flex: 1;
      margin-top: 2rem;
      margin-bottom: 2rem;
      border-top: 1px solid var(--fts-border);
    }
    .divider-label {
      padding-left: 1rem;
      padding-right: 1rem;
      padding-bottom: 0.25rem;
      color: var(--fts-default);
    }
  }
  .web-container {
    .web-run-app {
      margin-top: 0.5rem;
    }
    .web-run-label {
      margin-bottom: 0.5rem;
    }
  }
  .mobile-container {
    text-align: center;
  }
  .mobile-store-badge {
    display: inline-flex;
    > img {
      height: 40px;
    }
  }
  .qrcode {
    position: relative;
    display: inline-block;
    margin-top: 1.75rem;
    margin-bottom: 0.75rem;
    .qrcode-logo {
      @include absolute-center-middle;
      height: 36px;
      width: 36px;
      padding: 0.25rem;
      border-radius: 0.25rem;
      background-color: var(--fts-card-background);
    }
  }
  .invitation-container {
    .invitation-toggle {
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
    .invitation-helper {
      margin-top: 0.125rem;
      font-size: 0.75rem;
      line-height: 1rem;
      color: var(--fts-form-helper);
    }
    .invitation-form {
      margin-top: 2rem;
    }
  }
}
</style>